export enum ReviewNextStep {
    REQUIRES_ADDITIONAL_INFORMATION = 'Requires additional information',
    CLOSE_COD = 'Close COD'
}
